import { render, staticRenderFns } from "./ContactSupportInfo.vue?vue&type=template&id=27a8c612&"
import script from "./ContactSupportInfo.vue?vue&type=script&lang=js&"
export * from "./ContactSupportInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports